var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"lab-status-badge",style:(_vm.badgeStyle),attrs:{"variant":_vm.statusInfo.variant}},[_vm._v(" "+_vm._s(_vm.statusInfo.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }